<template>
	<Card :title="activity.title" :subtitle="trans(`events.activities.types.${activity.type}`)">
		<template #badges>
			<Badge v-if="activity.pivot.accredited_at" :color="Color.Green" active>{{ trans('general.accreditation.present') }}</Badge>
			<Badge v-else :color="Color.Red">{{ trans('general.accreditation.absent') }}</Badge>
		</template>
		<div v-if="activity.counts_toward_participation" class="text-sm text-green-600">
			<i class="fa-solid fa-check mr-2"/>
			{{ trans('events.activities.counts_toward_participation') }}
		</div>
		<div v-else class="text-sm text-red-600">
			<i class="fa-solid fa-xmark mr-2"/>
			{{ trans('events.activities.counts_toward_participation') }}
		</div>
		<template #footer>
			<SecondaryButton :color="Color.Blue" @click.stop="toggle">
				<i class="fa-solid fa-arrows-rotate mr-2"/>
				{{ trans('tools.accreditations.show.toggle') }}
			</SecondaryButton>
		</template>
	</Card>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineEmits, defineProps} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type SelectedActivity} from '@/Types/Events/Packs/Activities/SelectedActivity'

const props = defineProps<{
	activity: SelectedActivity,
}>()

const emit = defineEmits([
	'accredit',
	'ban',
])

function toggle():void{
	if(props.activity.pivot.accredited_at){
		emit('ban')
	} else {
		emit('accredit')
	}
}
</script>
